export { default } from './SkeletonCarRentalContainerMobile';
